import React, { Component, createRef } from "react";
import Button from "../button/Button";
import T from "../t/T";
import Api from "../../../core/api/Api";
import { _alert } from "../../../actions/Alert";
import { _loading } from "../../../actions/Loading";
import "./uploader.scss";
import { connect } from "react-redux";
import snippets from "../../../helpers/snippets";

const api = new Api();

class Uploader extends Component {
  FILE_TYPE = "";
  URL = "";
  constructor(props) {
    super(props);

    this.fileInputRef = createRef();

    this.state = {
      previewURL: null,
      message: {}
    };
  }

  componentDidMount() {
  }

  handleSelectFileDialog = () => {
    this.fileInputRef.current.click();
  }

  uploadFile = (fieldName = "", data, previewFile) => {
    let message = {
      type: "success",
      text: ""
    };

    let formData = new FormData();
    formData.append(fieldName, data);
    api.setPoint(this.URL);
    api.send("post", formData).then(response => {
      message.text = response.data.msg;
      this.setState({message: {
          type: message.type,
          text: 'upload_succeed'
        }}, ()=>{
        this.props?.onUploadCompleted?.(previewFile);
      })
    }).catch(error => {
      message.type = "error";
      message.text = error.message;
    }).finally(() => {
      this.props.dispatch(_loading(false));
      this.props.dispatch(_alert(true, message.type, message.text));
    });
  }

  onSelectedFileChange = (e, fieldName = "", multi) => {
    if (snippets.isObjectEmpty(e.target.files)) return
    this.props.dispatch(_loading(true));
    const fileURL = URL.createObjectURL(e.target.files[0]);
    const files = e.target.files;
    const allowedExtensions = this.FILE_TYPE.split(',');
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!allowedExtensions.some(ext => file.name.toLowerCase().endsWith(ext))) {
        this.setState({message: {
            type: 'error',
            text: `Please select valid image files (${this.FILE_TYPE.replaceAll('.', ' ')})`
          }
        })
        this.props.dispatch(_loading(false));
        return;
      }
    }
    this.setState({message: {}})
    
    if (files.length === 1){
      this.uploadFile(fieldName, e.target.files[0], fileURL);
    } else if (files.length > 1){
      this.uploadFile(fieldName, e.target.files, fileURL);
    } else {
      console.error("Uploader length Error!")
    }

    // this.setState({
    //   previewURL: fileURL
    // }, () => {
    // });
  }
  
  subButtonText = (supportedFormats) => {
    if (snippets.isObjectEmpty(this.state.message)){
      return <div className="uploader__supported_files"><T token={supportedFormats} /></div>
    } else if (this.state.message?.type){
      return <div className={`uploader__${this.state.message?.type}`}> <T token={this.state.message?.text} /> </div>
    }
  }

  render() {
    const {fieldName = "", application = null} = this.props;
    let multiSelect = false
    let buttonText = "";
    let supportedFormats
    
    if (!application) {
      throw new Error("application property is empty!!!");
    } else {
      switch(application.toLowerCase()) {
        case "signature":
          this.FILE_TYPE = ".png,.jpg,.jpeg";
          this.URL = "2/signature";
          buttonText = "upload_signature";
          supportedFormats = 'signature_format'
          break;
        case "add_patient":
          this.FILE_TYPE = ".png,.jpg,.jpeg,.pdf";
          this.URL = "2/signature";
          multiSelect = true
          buttonText = "upload_pictures";
          supportedFormats = 'add_patient_format'
          break;
        default:
          throw new Error("Wrong application entered!!!");
      }
    }

    return (
      <span className={'d-inline-flex flex-column justify-content-start'}>
        <input type="file" name={fieldName} accept={this.FILE_TYPE} className="uploader__file-input" ref={this.fileInputRef}
               onChange={event => this.onSelectedFileChange(event, fieldName, multiSelect)}
               multiple={multiSelect}
        />
        {/* {
          this.state.previewURL &&
          <div className="signature-container">
            <img src={this.state.previewURL} alt="Preview" className="signature" />
          </div>
        } */}
        <Button mode="warning-outline" onClick={this.handleSelectFileDialog}>
            <i className='fa-light fa-arrow-up-to-line' />
            <T token={buttonText}/>
        </Button>
        
        {this.subButtonText(supportedFormats)}
      </span>
    );
  }
}

export default connect()(Uploader);
